<template>
  <div :class="['kq-item-title', { 'is-border': isBorder }]" :style="{ marginBottom: marginBottom }">
    <div class="kq-item-left">
      <div class="kq-item-slide" :style="{ backgroundColor: lineColor }" />
      <div class="kq-item-content" :style="{ fontSize: size }">{{ title }}</div>
      <slot />
    </div>
    <div class="kq-item-right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'KqItemTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    padding: {
      type: String,
      default: '0 0 8px'
    },
    size: {
      type: String,
      default: '16px'
    },
    isBorder: {
      type: Boolean,
      default: false
    },
    lineColor: {
      type: String,
      default: '#345dff'
    },
    marginBottom: {
      type: String,
      default: '19px'
    }
  }
}
</script>

<style lang="scss" scoped>
.kq-item-title {
  width: 100%;
  height: 32px;
  display: flex;
  flex-direction: row;
  position: relative;

  &.is-border::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #e6ebf5;
  }

  .kq-item-left {
    flex: 1 1 0;
    height: 32px;
    display: flex;
    align-items: center;
  }

  .kq-item-slide {
    width: 4px;
    height: 12px;
    border-radius: 4px;
  }

  .kq-item-content {
    margin-left: 6px;
    color: $color-text-main;
    font-weight: bold;
  }

  .kq-item-right {
    height: 32px;
    display: flex;
    align-items: center;
  }

  .el-button.el-button--text {
    padding: 2px 0 !important;
  }
}
</style>
